/**
 * Formats JSON content in plotly code blocks within markdown content.
 * Finds all ```plotly code blocks, parses the JSON, and formats it with proper indentation.
 *
 * @param content - Markdown content string
 * @returns Formatted markdown content with formatted JSON in plotly blocks
 */
export default function formatPlotlyJsonInMarkdown(content?: string): string {
  if (!content) {
    return content || '';
  }

  // Regex to match plotly code blocks: ```plotly ... ```
  const plotlyCodeBlockRegex = /```plotly\n?([\s\S]*?)```/g;

  return content.replace(plotlyCodeBlockRegex, (match, jsonContent) => {
    const trimmedContent = jsonContent.trim();
    if (!trimmedContent) {
      return match;
    }

    try {
      // Parse and format the JSON
      const parsed = JSON.parse(trimmedContent);
      const formatted = JSON.stringify(parsed, null, 2);
      return `\`\`\`plotly\n${formatted}\n\`\`\``;
    } catch {
      // If parsing fails, return original match
      return match;
    }
  });
}
